const Services = () => {
    return (
        <section id="services" className="px-6 md:px-28 py-24 bg-slate-900">
            <div className="flex">
                <div className="bg-primary h-9 w-2 mr-3" />
                <p className="text-4xl font-bold">Services</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-12">
                <div className="bg-black border-l border-primary py-8 px-6 relative">
                    <div className="flex mb-4 items-center absolute translate-x-[-20%]">
                        <div className="bg-primary w-12 h-12 flex justify-center items-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                dataSlot="icon"
                                className="w-8 h-8"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25"
                                />
                            </svg>
                        </div>
                        <div className="flex flex-col ml-2">
                            <p className="text-primary text-lg">01</p>
                            <p className="text-xl font-bold">
                                Solutions architecture
                            </p>
                        </div>
                    </div>
                    <p className="text-sm mt-20 capitalize text-gray-400">
                        Design scalable, efficient, and maintainable system
                        architectures tailored to your business goals.
                    </p>
                </div>
                <div className="bg-black border-l border-primary py-8 px-6 relative">
                    <div className="flex mb-4 items-center absolute translate-x-[-15%]">
                        <div className="bg-primary w-12 h-12 flex justify-center items-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                dataSlot="icon"
                                className="w-8 h-8"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5"
                                />
                            </svg>
                        </div>
                        <div className="flex flex-col ml-2">
                            <p className="text-primary text-lg">02</p>
                            <p className="text-xl font-bold">Web Development</p>
                        </div>
                    </div>
                    <p className="text-sm mt-20 capitalize text-gray-400">
                        Create custom and scalable fullstack web applications
                        that are tailored to your business needs and
                        requirements.
                    </p>
                </div>
                <div className="bg-black border-l border-primary py-8 px-6 relative">
                    <div className="flex mb-4 items-center absolute translate-x-[-14%]">
                        <div className="bg-primary w-12 h-12 flex justify-center items-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                dataSlot="icon"
                                className="w-8 h-8"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 0 1-.657.643 48.39 48.39 0 0 1-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 0 1-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 0 0-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 0 1-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 0 0 .657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 0 0 5.427-.63 48.05 48.05 0 0 0 .582-4.717.532.532 0 0 0-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 0 0 .658-.663 48.422 48.422 0 0 0-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 0 1-.61-.58v0Z"
                                />
                            </svg>
                        </div>
                        <div className="flex flex-col ml-2">
                            <p className="text-primary text-lg">03</p>
                            <p className="text-xl font-bold">
                                DevOps & Deployment
                            </p>
                        </div>
                    </div>
                    <p className="text-sm mt-20 capitalize text-gray-400">
                        Deploy and manage your web applications on secure,
                        scalable infrastructure—ensuring smooth CI/CD, version
                        control, and environment management.
                    </p>
                </div>
                <div className="bg-black border-l border-primary py-8 px-6 relative">
                    <div className="flex mb-4 items-center absolute translate-x-[-16%]">
                        <div className="bg-primary w-12 h-12 flex justify-center items-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                dataSlot="icon"
                                className="w-8 h-8"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                                />
                            </svg>
                        </div>
                        <div className="flex flex-col ml-2">
                            <p className="text-primary text-lg">04</p>
                            <p className="text-xl font-bold">
                                Creative Writing
                            </p>
                        </div>
                    </div>
                    <p className="text-sm mt-20 capitalize text-gray-400">
                        Write compelling articles on health and technology
                        related news to guarantee lead conversions.
                    </p>
                </div>
            </div>
        </section>
    )
}

export default Services
